import styled, { css } from 'styled-components';

export const Frame = styled.div(
  ({ theme }) => css`
    flex-shrink: 0;
    width: ${theme.sz.s10};
    height: ${theme.sz.s10};
    overflow: hidden;
    border: ${theme.bo.mediumWidth} solid ${theme.co.neutral99};
    border-radius: ${theme.bo.round};
    background-color: ${theme.co.neutral30};
  `,
);

export const FaceImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
`;
